var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSquareYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282,256.2l-95.2-54.1v108.2l95.2-54.1ZM384,32H64C28.7,32,0,60.7,0,96v320c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64V96c0-35.3-28.7-64-64-64ZM398.4,168.1c7.6,28.6,7.6,88.2,7.6,88.2,0,0,0,59.6-7.6,88.1-4.2,15.8-16.5,27.7-32.2,31.9-28.3,7.7-142.2,7.7-142.2,7.7,0,0-113.9,0-142.2-7.6-15.7-4.2-28-16.1-32.2-31.9-7.6-28.6-7.6-88.2-7.6-88.2,0,0,0-59.7,7.6-88.2,4.2-15.8,16.5-28.2,32.2-32.4,28.3-7.7,142.2-7.7,142.2-7.7,0,0,113.9,0,142.2,7.7,15.7,4.2,28,16.6,32.2,32.4h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquareYoutube);
export default __webpack_public_path__ + "static/media/icon-square-youtube.c59b502ddba7e51dfe44e48f6d6abb7e.svg";
export { ForwardRef as ReactComponent };